export default function parseAspectRatioString(aspectRatio: string): { width: number, height: number } {
    const ratioParts = aspectRatio.split(':');
    if (ratioParts.length !== 2 || !isFinite(+ratioParts[0]) || !isFinite(+ratioParts[1])) {
        throw new Error(
            'aspectRatio must be in the format "x:y" like "16:9". Got "' +
            aspectRatio + '"'
        );
    }
    return {
        width: parseInt(ratioParts[0]),
        height: parseInt(ratioParts[1]),
    }
}